import { range, values, keyBy } from 'lodash';

import * as OvationsApi from 'core/ovations-api';

const rewardPackageTypeCount = Object.keys(OvationsApi.Enums.RewardPackageType).length;
const rewardPackageState = {
    map: keyBy(
        range(1, rewardPackageTypeCount + 1).map((i) => ({
            id: String(i),
            cardEnginePackageId: String(i),
            reportId: null,
            projectedMailDateSLAInDays: null,
            retailerTitle: '',
            name: `Mock RewardPackage ${i}`,
            programId: `program-1`,
            isArchived: false,
            isUsed: false,
            rewardPackageType: Object.keys(OvationsApi.Enums.RewardPackageType)[
                i % rewardPackageTypeCount
            ] as OvationsApi.Enums.RewardPackageType,
            number: 1,
            notes: 'Mock notes',
            customerFacingName: i % 2 === 0 ? 'New Name' : '',
        })),
        'id',
    ),
    activeRewardTypes: [
        'SingleLoadUSA',
        'ReloadableUSA',
        'SingleLoadCAN',
        'ReloadableCAN',
        'VirtualUSA',
        'CheckUSA',
        'Points',
        'RetailCard',
        'ReloadableCANVisa',
    ] as OvationsApi.Types.RewardPackageTypeValue[],
};
const statuses = values(OvationsApi.Enums.PromotionState) as OvationsApi.Enums.PromotionState[];

export const mockStaticRewardCalculation: OvationsApi.Types.StaticRewardCalculation = {
    id: 1,
    type: OvationsApi.Enums.RewardCalculationType.Static,
    label: 'Static Reward',
    rewardPackages: [rewardPackageState.map['1']],
    amount: 1,
    alternatePayeeRewardPackageId: '_alternatePayeeRewardPackageId_',
    alternatePayeeRewardPackageType: OvationsApi.Enums.RewardPackageType.SingleLoadUSA,
    rewardPackageName: 'Single load package name',
    sortOrder: 0,
};

export const mockVariableRewardCalculation: OvationsApi.Types.VariableRewardCalculation = {
    id: 1,
    type: OvationsApi.Enums.RewardCalculationType.Variable,
    label: 'Variable Reward',
    rewardPackages: [rewardPackageState.map['1']],
    amount: 1,
    alternatePayeeRewardPackageId: '_alternatePayeeRewardPackageId_',
    alternatePayeeRewardPackageType: OvationsApi.Enums.RewardPackageType.SingleLoadUSA,
    values: {},
    dropdownQuestion: null,
    rewardPackageName: 'Variable reward package name',
    sortOrder: 0,
    cascadingDropdownQuestion: null,
};

export const mockPromotions: OvationsApi.Types.Promotion[] = range(1, 7).map((i) => ({
    checkDuplicatesAcrossProgram: false,
    createDate: `2018-0${i}-20T20:00:08.734Z`,
    id: String(i),
    programId: 'program-1',
    name: `Mock Promotion ${i}`,
    number: i,
    purchaseStart: null,
    purchaseStartGracePeriod: '',
    purchaseEnd: null,
    purchaseEndGracePeriod: '',
    websiteSubmissionStart: `2018-0${i}-20T20:00:08.734Z`,
    websiteSubmissionEnd: `2018-0${i + 1}-20T20:00:08.734Z`,
    mailSubmissionStart: null,
    mailSubmissionEnd: null,
    missingLanguages: [],
    promotionClose: null,
    ownerName: '',
    contactNumber: '',
    contactName: '',
    contactEmail: '',
    estimatedRedemptions: 0,
    poBox: '',
    poNumber: '',
    suiteNumber: '',
    callCenterTollFreeNumber: '',
    questions: [],
    requiresPrefunding: false,
    rewardCalculations: null,
    promotionLimit: null,
    state: statuses[i - 1],
    termsAndConditions: null,
    termsAndConditionsHeading: null,
    eSignAgreementUrl: null,
    rewardPrefundEnabled: false,
    hasAlternatePayee: false,
    eligibilityGroups: [],
    promotionGroup: undefined,
    promotionType: OvationsApi.Enums.PromotionType.ClaimSubmission,
    claimRedemptionExpiration: null,
    overrideManualValidation: false,
    clientOfferId: '',
    referralConfirmation: false,
    householdLimit: null,
    householdLimitType: OvationsApi.Enums.HouseholdLimitTypeValue.None,
    householdLimitResetType: null,
    hasHouseholdLimitResetType: false,
    timeLimit: null,
    bulkImportEnabled: false,
    checksMemo: '',
    checksDescription: '',
    checksBankAccountNumber: '',
    checksTelephoneNumber: '',
    checksVendorNumber: '',
}));

export const mockPromotion = mockPromotions[0];

export const mockPromotionSummaries: OvationsApi.Types.PromotionSummary[] = range(1, 7).map((i) => ({
    id: String(i),
    programId: 'program-1',
    name: `Mock Promotion ${i}`,
    number: i,
    questions: [],
    state: statuses[i - 1],
    rewardPackageTypes: [],
    rewardPrefundEnabled: false,
    promotionType: OvationsApi.Enums.PromotionType.ClaimSubmission,
    customerFacingName: '',
}));

export const mockPromotionSummary = mockPromotionSummaries[0];
